import { trpc } from '@tencent/tpro_rmonitor_manage_server_issue_track';
import { TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import {
  IModifyIssueStatusRsp,
} from '@/proto/manage';
import IBatchModifyIssueStatusReq = trpc.rmonitor.manage_server.IBatchModifyIssueStatusReq;


export const batchModifyIssueStatus = async (params: IBatchModifyIssueStatusReq):
Promise<IModifyIssueStatusRsp | undefined> => {
  try {
    return await TRPCPost<IModifyIssueStatusRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/BatchModifyIssueStatus`, params);
  } catch (e) {
    logger.error('modifyIssueStatusBatch err', e);
    return undefined;
  }
};
